import { FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';

import styles from './actionMenu.module.scss';

interface Props {
  platformId: string;
  onUpdate: (id: string) => void;
  onDelete: (id: string) => void;
}

export function ActionMenu({
  platformId,
  onUpdate,
  onDelete,
}: Props): JSX.Element {
  return (
    <FlexBox flexDirection="row" justifyContent="end">
      <Tooltip content="Edit platform">
        <IconButton
          className={styles.buttonSpacing}
          icon="pen"
          variant="tertiary"
          onClick={() => onUpdate(platformId)}
        />
      </Tooltip>
      <Tooltip content="Delete platform">
        <IconButton
          className={styles.buttonSpacing}
          icon="trash"
          variant="tertiary"
          onClick={() => onDelete(platformId)}
        />
      </Tooltip>
    </FlexBox>
  );
}
